<template>
  <Checkbox
    @focus="focus = true"
    @blur="focus = false"
    @mouseover="hover = true"
    @mouseleave="hover = false"
    :binary="!value"
    :value="value"
    :pt="{
      box: ({ context }) => ({
        class: [
          hover ? 'border-theme/25 dark:border-theme/75':'',
          focus ? 'ring-theme/30 ring-2':'',
          context.checked ? 'border-theme' : 'border-gray-300 dark:border-slate-800',
          'bg-transparent dark:bg-slate-600'
        ]
      })
    }"
  >
    <template #icon="{ checked }">
      <div
        :class="[
          checked ? 'w-[72%] h-[72%] bg-theme rounded':'w-[0px] h-[0px]',
          transitionClass,
          'duration-75'
        ]"
      ></div>
    </template>
  </Checkbox>
</template>

<script>

import Checkbox from 'primevue/checkbox';

export default {
  name: "RpmCheckboxInput",
  components: {
    Checkbox,
  },
  data() {
    return {
      focus: false,
      hover: false,
    };
  },
  props: {
    value: {},
    focusClass: {
      type: String,
      default: ""
    },
    transitionClass: {
      type: String,
      default: ""
    },
    placeHolderClass: {
      type: String,
      default: ""
    },
    focusFocusClass: {
      type: String,
      default: ""
    },
    disabledClass: {
      type: String,
      default: ""
    },
    paddingClass: {
      type: String,
      default: ""
    },
    borderClass: {
      type: String,
      default: ""
    },
    panelClass: {
      type: String,
      default: ""
    },
    textClass: {
      type: String,
      default: ""
    },
  },
};
</script>
